<template>
	<div>
		<div class="thead no-border">
			<table class="tbl v-tbl outline location-table">
				<colgroup>
					<col width="150px">
					<col width="25%">
					<col width="25%">
					<col width="50%">
				</colgroup>
				<thead class="thead-outline">
					<tr>
						<th>구분</th>
						<th>관</th>
						<th>층</th>
						<th>상세위치</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(dep2, dep2Index) in select2Depth">
						<template v-for="(dep3, dep3Index) in getFilterd(dep2)">
							<tr v-for="(dep4, dep4Index) in getFilterd(dep3)" :key="dep4Index">
								<td v-if="dep3Index == 0 && dep4Index == 0" :rowspan="getDep2RowSpan(dep2)">
<!--								<td v-if="dep4Index == 0" :rowspan="dep3.children.length">-->
									<label class="md-check">
										{{dep2.locationName}}
									</label>
								</td>
								<td v-if="dep4Index == 0" :rowspan="dep3.children.length">
									<label class="md-check" >
										{{dep3.locationName}}
									</label>
								</td>
								<td>
									<label class="md-check">
										{{dep4.locationName}}
									</label>
								</td>
								<td>
									<div style="display:flex; flex-direction: row; align-items:center">
										<div style="flex:1">
											<label class="md-check" v-for="(dep5, dep5Index) in getFilterd(dep4)" :key="dep5Index">
												<input type="checkbox" :disabled="!dep5.isCustom" v-model="dep5.checked" @change="changeHandler(dep5)">
												<i class="blue"></i>{{dep5.locationName}}
											</label>
										</div>
										<div>
											<button class="btn btn-sm blue" v-if="isAddButton" @click="add(dep3)">추가<i class="icon-plus  ml-5"></i></button>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import LocationList from '@/views/app/location/LocationList.vue';
import LocationBase from '@/components/common/locationBase'
export default {
  mixins: [LocationBase],
  props: ['title', 'description', 'selectIdcCode', 'isAddButton','slectedIdcCodeList'],
	components: {
		PageHeader,
		LocationList,
	},
	data(){
    return {
      baseLocation: 'N2CDT002580',
      idcList: null,
			select2Depth: null,
			select3Depth: [],
			select4Depth: null,
			currentIdcTotalRow:0,
			selectedList: {},
    }
  },
	computed: {

		getFilterd(){
			return (arr)=>{
				var that = this;
				arr.children.forEach(x => {
						var b= that.getSelected(x);
						x.checked = that.getSelected(x);
						if(x.checked){
							debugger
						}
					}
				);
				return arr.children.filter(x => x.isDeleteYN == "N");
			}
		}
	},
	mounted(){
		this.init();
	},
	methods: {
  		getDep2RowSpan(dep2){
			let cnt = 0;
			for(let i = 0 ; i < dep2.children.length ; i++){
				let dep3 = dep2.children[i];
				cnt += dep3.children.length;
				// for(let j = 0 ; j < dep3.length ; j++){
				// 	cnt += dep2[i].children[j].children.length
				// }
			}
			return cnt;
		},
		getSelected(item){
			if(this.slectedIdcCodeList){
				return this.slectedIdcCodeList.map(x=>{return x.filter(y=>y == item.locationCode).length > 0}).filter(z=>z == true).length > 0
			}else{
				return false;
			}
		},
		init(){
			this.loadLocation();
		},
		async loadLocation(){
			let location = await this.$store.getters['location/location'];
			debugger;
			this.idcList = location.filter(x => x.isDeleteYN == "N");
			if(!this.selectedLocation)
				this.selectedLocation = this.idcList[0];
			if(this.selectIdcCode)
				this.selectedLocation  = location.filter(x=>x.locationCode == this.selectIdcCode)[0];
			this.idcSelect(this.selectedLocation);
			this.makeKey();
    },

		idcSelect(item){

			var that = this;
			this.currentIdcTotalRow = 0;
			this.select2Depth = item.children;
			this.select3Depth = [];
			this.select2Depth.forEach((item) => {
				that.select3Depth = that.select3Depth.concat(item.children);
				//that.currentIdcTotalRow += item.children.length;
			});

		},
		add(row){
			this.openModal({view: 'app/location/LocationAdd', side: false, mode: 'new' , title: '출입자 별 입실 정보 입력', data: {data: row}, showBottom: false})
			//this.openModal({view: 'app/location/locationForm', side: false, mode: 'new' , title: '위치 추가', data: {data: row}, showBottom: false})
		},
		changeHandler(item){
			debugger;
			if(item.checked)
				this.selectedList[item.locationCode] = item;
			else
				delete this.selectedList[item.locationCode];
			this.$emit('selectedLocation', this.selectedList);
		}
	}
}
</script>

<style>
	.thead-outline {
		border: solid 1px #e2e2e2;
		-webkit-box-shadow: none;
		box-shadow: none;
	}
</style>
